import script from "./form-element-lateral.vue?vue&type=script&setup=true&lang=js"
export * from "./form-element-lateral.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__